import { Divider, Typography, Box } from '@material-ui/core';
import React from 'react';
import TickRow from '../TickRow';
import Contained from 'components/Button/Contained';

const DataDetail = [
	{
		id: 1,
		title: 'جانبو',
		price: '875,000',
		payment: false,
		start: 1,
		end: 4,
	},
	{
		id: 2,
		title: 'دندان پزشکی مریم',
		price: '875,000',
		payment: false,
		start: 4,
		end: 4,
	},
];
const ContentInfo = () => {
	return (
		<Box width={'100%'}>
			<Box width={'100%'}>
				<Typography style={{ color: '#101740', fontSize: '18px', fontWeight: 700 }}>اقساط معوق</Typography>
			</Box>
			<Box width={'100%'} item xs={12} style={{ marginTop: '27px' }}>
				<Typography tyle={{ color: '#888BA0', fontSize: '16px', fontWeight: 500 }}>
					این مبلغ مربوط مجموع اقساط معوق پرداخت نشده دوره های زیر است که به دوره جاری اضافه شده است:
				</Typography>
			</Box>
			<Box width={'100%'} style={{ marginTop: '27px' }}>
				{React.Children.toArray(
					DataDetail?.map((item, key) => (
						<>
							<TickRow {...item} />
							{key < DataDetail?.length - 1 && <Divider style={{ color: '#E9E9F0', margin: '16px 0' }} />}
						</>
					)),
				)}
			</Box>
			<Box width={'100%'} mt="24px">
				<Contained>فهمیدم</Contained>
			</Box>
		</Box>
	);
};

export default ContentInfo;
